import { render, staticRenderFns } from "./chelianglayunzhanbiDetail.vue?vue&type=template&id=6823aa2c&scoped=true&"
import script from "./chelianglayunzhanbiDetail.vue?vue&type=script&lang=js&"
export * from "./chelianglayunzhanbiDetail.vue?vue&type=script&lang=js&"
import style0 from "./chelianglayunzhanbiDetail.vue?vue&type=style&index=0&id=6823aa2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823aa2c",
  null
  
)

export default component.exports